import React from 'react';
import './App.css';
import Header from "./components/Header";
import SubHeader from './components/Subheader';
import PricingPlans from './components/PricingPlans';
import AdditionalServicesWithImages from './components/AdditionalServicesWithImages';
import Benefits from './components/Benefits';
import ContactForm from './components/ContactForm';
import SubscriptionsTimeline from './components/SubscriptionsTimeline';
import Testimonials from './components/Testimonials';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
function App() {
  return (
    <div className="bg-[rgb(25,24,31)] min-h-screen text-white">
      <Header />
      <SubHeader />
      <Benefits />
      <PricingPlans />
      {/* <AdditionalServicesSimple /> */}
      <AdditionalServicesWithImages />
      <Testimonials />
      <SubscriptionsTimeline />
      <ContactForm />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

export default App;